(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lus-cart-installation-request"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('luscentra-installation-request')) {
    class LuscentraInstallationRequest extends HTMLElement {
      connectedCallback() {
        this.requestCheckbox = this.querySelector('[data-installation-request-checkbox]');
        this.consentCheckbox = this.querySelector('[data-installation-consent-checkbox]');
        this.consentPanel = this.querySelector('[data-installation-consent-panel]');
        this.status = this.querySelector('[data-installation-request-status]');
        if (!this.requestCheckbox || !this.consentCheckbox) {
          this.hidden = true;
          return;
        }
        this.requestCheckbox?.addEventListener('change', (event) => {
          event.stopPropagation();
          this.updateRequestChoice();
        });
        this.consentCheckbox?.addEventListener('change', (event) => {
          event.stopPropagation();
          this.updateConsentChoice();
        });

        const hasStarterKit = this.dataset.hasStarterKit === 'true';
        const selected = this.dataset.selected === 'true';
        const consented = this.dataset.consented === 'true';
        const modelsChanged = this.dataset.models !== this.dataset.storedModels;
        const itemsChanged = this.dataset.items !== this.dataset.storedItems;

        this.syncConsentState(selected, consented);
        if (selected && consented && (!hasStarterKit || modelsChanged || itemsChanged)) {
          this.persistRequest(hasStarterKit && consented).catch(() => {});
        }
      }

      syncConsentState(requested, consented) {
        this.requestCheckbox.checked = requested;
        this.consentCheckbox.checked = requested && consented;
        this.consentCheckbox.required = requested;
        this.consentCheckbox.setAttribute('aria-required', String(requested));
        this.consentPanel.hidden = !requested;
        this.toggleCheckoutGuard(requested && !consented);
      }

      toggleCheckoutGuard(blocked) {
        this.dataset.checkoutBlocked = String(blocked);
        const anyBlocked = [...document.querySelectorAll('luscentra-installation-request')]
          .some((request) => !request.hidden && request.dataset.checkoutBlocked === 'true');
        document.documentElement.classList.toggle('lus-installation-consent-pending', anyBlocked);
      }

      async updateRequestChoice() {
        const requested = this.requestCheckbox.checked;
        const previous = this.dataset.selected === 'true';
        this.status.textContent = '';

        if (requested) {
          this.syncAcrossInstances(true, false, false);
          this.status.textContent = this.dataset.pendingMessage;
          this.consentCheckbox.focus();
          return;
        }

        this.setAttribute('aria-busy', 'true');
        try {
          await this.persistRequest(false);
          this.status.textContent = this.dataset.clearedMessage;
        } catch (error) {
          this.syncAcrossInstances(previous, previous, previous);
          this.status.textContent = this.dataset.errorMessage;
        } finally {
          this.removeAttribute('aria-busy');
        }
      }

      async updateConsentChoice() {
        const consented = this.consentCheckbox.checked;
        const requested = this.requestCheckbox.checked;
        if (!requested) return;
        this.setAttribute('aria-busy', 'true');
        this.status.textContent = '';

        try {
          await this.persistRequest(consented);
          this.status.textContent = consented
            ? this.dataset.selectedMessage
            : this.dataset.requiredMessage;
        } catch (error) {
          this.syncAcrossInstances(true, false, false);
          this.status.textContent = this.dataset.errorMessage;
        } finally {
          this.removeAttribute('aria-busy');
        }
      }

      async persistRequest(requested) {
        if (!window.luscentraInstallationRequestUpdate) {
          const source = this;
          const root = window.Shopify?.routes?.root || '/';
          const consentedAt = new Date().toISOString();
          const attributes = {
            'Free installation requested': requested ? 'Yes' : null,
            'Installation kit models': requested ? source.dataset.models : null,
            'Installation kit items': requested ? source.dataset.items : null,
            'Installation WhatsApp consent': requested ? 'Yes' : null,
            'Installation consent captured at': requested ? consentedAt : null,
            'Installation consent source': requested ? 'complimentary installation request' : null,
            'Installation consent form version': requested ? 'cart-installation-v2' : null,
            'Installation consent disclosure': requested ? 'installation-whatsapp-service-v2' : null,
            'Installation consent type': requested ? 'whatsapp_transactional_service' : null,
            'Installation consent cart token': requested ? source.dataset.cartToken : null
          };

          window.luscentraInstallationRequestUpdate = fetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ attributes })
          }).then((response) => {
            if (!response.ok) throw new Error('Cart update failed');
            return response.json();
          }).finally(() => {
            window.luscentraInstallationRequestUpdate = null;
          });
        }

        await window.luscentraInstallationRequestUpdate;
        this.syncAcrossInstances(requested, requested, requested);
      }

      syncAcrossInstances(requested, consented, persisted) {
        document.querySelectorAll('luscentra-installation-request').forEach((request) => {
          request.dataset.selected = String(persisted);
          request.dataset.consented = String(consented);
          request.dataset.storedModels = persisted ? request.dataset.models : '';
          request.dataset.storedItems = persisted ? request.dataset.items : '';
          request.syncConsentState(requested, consented);
        });
      }
    }

    customElements.define('luscentra-installation-request', LuscentraInstallationRequest);

    document.addEventListener('click', (event) => {
      const checkout = event.target.closest('[name="checkout"]');
      if (!checkout) return;
      const blockedRequest = [...document.querySelectorAll('luscentra-installation-request')]
        .find((request) => !request.hidden && request.requestCheckbox?.checked && !request.consentCheckbox?.checked);
      if (!blockedRequest) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      blockedRequest.status.textContent = blockedRequest.dataset.requiredMessage;
      blockedRequest.consentCheckbox.focus();
      blockedRequest.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lus-cookie-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    const notice = document.querySelector('[data-lus-cookie-notice]');
    if (!notice) return;

    const storageKey = 'luscentra_cookie_notice_seen_v2';
    const cookieName = 'luscentra_cookie_notice_seen';
    const dismissButton = notice.querySelector('[data-lus-cookie-dismiss]');
    let dismissed = false;
    let lastObservedScrollY = window.scrollY;
    let userScrollDistance = 0;
    let userScrollIntentUntil = 0;
    let lastTouchY = null;

    const cookieWasSet = () => document.cookie
      .split('; ')
      .some((part) => part.startsWith(`${cookieName}=`));

    const hasBeenSeen = () => {
      try {
        return window.localStorage.getItem(storageKey) === '1';
      } catch (error) {
        return cookieWasSet();
      }
    };

    const markAsSeen = () => {
      try {
        window.localStorage.setItem(storageKey, '1');
      } catch (error) {
        const secure = window.location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = `${cookieName}=1; Max-Age=31536000; Path=/; SameSite=Lax${secure}`;
      }
    };

    const syncBottomOffset = () => {
      const selectors = [
        '.lus-pdp__sticky[data-lus-ready]:not([hidden])',
        '.lus-home-sticky-shop:not([hidden])',
        '.lus-wq__sticky:not([hidden])'
      ];
      let offset = window.matchMedia('(max-width: 749px)').matches ? 12 : 16;

      selectors.forEach((selector) => {
        const element = document.querySelector(selector);
        if (!element) return;
        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        if (style.visibility === 'hidden' || Number(style.opacity) === 0 || rect.height === 0) return;
        if (rect.bottom >= window.innerHeight - 2) {
          offset = Math.max(offset, Math.ceil(window.innerHeight - rect.top + 12));
        }
      });

      notice.style.setProperty('--lus-cookie-bottom', `${offset}px`);
    };

    const dismiss = () => {
      if (dismissed) return;
      dismissed = true;
      markAsSeen();
      notice.classList.remove('is-visible');
      notice.classList.add('is-leaving');
      document.body.classList.remove('lus-cookie-notice-open');
      window.setTimeout(() => {
        notice.hidden = true;
      }, 300);
    };

    if (hasBeenSeen()) return;

    markAsSeen();
    syncBottomOffset();
    notice.hidden = false;
    document.body.classList.add('lus-cookie-notice-open');
    window.requestAnimationFrame(() => notice.classList.add('is-visible'));

    dismissButton?.addEventListener('click', dismiss);
    window.addEventListener('resize', syncBottomOffset, { passive: true });
    window.setTimeout(syncBottomOffset, 400);

    const noteUserScrollIntent = () => {
      userScrollIntentUntil = window.performance.now() + 900;
    };

    window.addEventListener('wheel', (event) => {
      if (event.deltaY > 0 && Math.abs(event.deltaY) >= Math.abs(event.deltaX)) {
        noteUserScrollIntent();
      }
    }, { passive: true });

    window.addEventListener('touchstart', (event) => {
      lastTouchY = event.touches[0]?.clientY ?? null;
    }, { passive: true });

    window.addEventListener('touchmove', (event) => {
      const currentTouchY = event.touches[0]?.clientY;
      if (lastTouchY !== null && currentTouchY !== undefined && currentTouchY < lastTouchY - 4) {
        noteUserScrollIntent();
      }
      lastTouchY = currentTouchY ?? null;
    }, { passive: true });

    window.addEventListener('touchend', () => {
      lastTouchY = null;
    }, { passive: true });

    window.addEventListener('keydown', (event) => {
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (!['ArrowDown', 'PageDown', ' ', 'End'].includes(event.key)) return;

      const activeElement = document.activeElement;
      if (activeElement?.matches('input, textarea, select, button, a, [contenteditable="true"]')) return;
      noteUserScrollIntent();
    });

    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      const scrollDelta = currentScrollY - lastObservedScrollY;
      lastObservedScrollY = currentScrollY;

      if (window.performance.now() > userScrollIntentUntil || scrollDelta <= 0) return;

      userScrollDistance += scrollDelta;
      const threshold = Math.max(120, Math.min(180, window.innerHeight * 0.14));
      if (userScrollDistance >= threshold) dismiss();
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
